var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkPremium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4747_254",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 29,
    height: 29
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.59375,
    y: 0.158936,
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4747_254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8826 16.1423L12.9034 12.8173L10.2201 10.659H13.5451L14.5951 7.39231L15.6451 10.659H18.9701L16.2576 12.8173L17.2784 16.1423L14.5951 14.0715L11.8826 16.1423ZM7.59505 26.9923V17.9798C6.85616 17.1631 6.28255 16.2298 5.87422 15.1798C5.46589 14.1298 5.26172 13.0118 5.26172 11.8256C5.26172 9.22009 6.16589 7.01314 7.97422 5.20481C9.78255 3.39648 11.9895 2.49231 14.5951 2.49231C17.2006 2.49231 19.4076 3.39648 21.2159 5.20481C23.0242 7.01314 23.9284 9.22009 23.9284 11.8256C23.9284 13.0118 23.7242 14.1298 23.3159 15.1798C22.9076 16.2298 22.3339 17.1631 21.5951 17.9798V26.9923L14.5951 24.659L7.59505 26.9923ZM14.5951 18.8256C16.5395 18.8256 18.1923 18.1451 19.5534 16.784C20.9145 15.4229 21.5951 13.7701 21.5951 11.8256C21.5951 9.8812 20.9145 8.22842 19.5534 6.86731C18.1923 5.5062 16.5395 4.82564 14.5951 4.82564C12.6506 4.82564 10.9978 5.5062 9.63672 6.86731C8.27561 8.22842 7.59505 9.8812 7.59505 11.8256C7.59505 13.7701 8.27561 15.4229 9.63672 16.784C10.9978 18.1451 12.6506 18.8256 14.5951 18.8256Z",
    fill: "#EA7F4A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkPremium);
export default __webpack_public_path__ + "static/media/work-premium.441ea22044d6e8cc1ac88eb24226ea63.svg";
export { ForwardRef as ReactComponent };